import { FC } from "react";
import * as _ from "lodash";
import { Enterprise, useTranslation } from "@ctra/i18n";
import { Nullable, Units } from "@ctra/utils";
import { ScorecardValueEntity } from "@ctra/api";

interface ScorecardValueProps {
  isLoading?: boolean;
  value: Nullable<ScorecardValueEntity["value"]>;
  unit: string;
}

/**
 * Formatted scorecard value
 * @param isLoading
 * @param value
 * @param unit
 * @constructor
 */
export const ScorecardValue: FC<ScorecardValueProps> = ({ isLoading, value, unit }) => {
  const { t } = useTranslation();

  const {
    kpi,
    unitSystem: { unit: tUnit }
  } = Enterprise;

  return (
    <>
      {isLoading
        ? "..."
        : _.isNull(value)
        ? t<string>(kpi.scorecard.data.notAvailable)
        : Units.format(value, unit, t<string>(tUnit(unit)), {
            precision: 1
          })}
    </>
  );
};
